export const GET_DETAILS = 'GET_DETAILS';
export const POST_DETAILS = 'POST_DETAILS';